import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrash = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.14282 7.64648H6.66663H18.8571",
			stroke: "currentColor",
			strokeWidth: 1.28571,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.85706 7.64648H17.1427L16.4865 18.146C16.3736 19.953 14.8751 21.3607 13.0646 21.3607H10.9352C9.12466 21.3607 7.62621 19.953 7.51328 18.146L6.85706 7.64648Z",
			stroke: "currentColor",
			strokeWidth: 1.28571
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.42847 6.78919C9.42847 5.36904 10.5797 4.21777 11.9999 4.21777V4.21777C13.42 4.21777 14.5713 5.36904 14.5713 6.78919V7.64633H9.42847V6.78919Z",
			stroke: "currentColor",
			strokeWidth: 1.28571
		})
	]
});
export default SvgTrash;
